/* APPLICATION ROUTE CONSTANTS */
module.exports = Object.freeze({
  ROW_PER_PAGE: [10, 50, 100, 300, 500],

  // Status
  STATUS_REGISTER: "Register",

  /* Routers Link ledger_app */
  APP_HOME: "/applications",
  HOME: "/home",

  HOME_INTRO: "/pl-intro",
  DASHBOARD: "/pl-dashboard",
  INBOX: "/pl-inbox",
  OUTBOX: "/pl-outbox",

  //Cash request
  LEDGER_CASH_REQUEST_LIST: "/pl-cash-request-list",
  LEDGER_CASH_REQUEST_UPDATE: "/pl-cash-request-update",
  LEDGER_CASH_REQUEST_CREATE: "/pl-cash-request-create",

  LEDGER_BANK_STATEMENT: "/pl-bank-statement",
  LEDGER_DAILY_EXPENSES: "/pl-cash-expenses",

  LEDGER_CASH_EXPENSES_DETAILS: "/pl-cash-expenses-details",
  LEDGER_BANK_STATEMENT_DETAILS: "/pl-bank-statement-details",

  LEDGER_CASH_EXPENSES2_DETAILS: "/pl-cash-expenses2-details",
  LEDGER_CASH_EXPENSES_LIST: "/pl-cash-expenses-list",

  LEDGER_PAYMENT_VOUCHER: "/pl-payment-voucher",
  LEDGER_PAYMENT_RECEIPT: "/pl-receipt-voucher",

  /* CSTOMER INVOICE */
  LEDGER_INVOICE_DETAILS: "/pl-customer-invoice-details",
  LEDGER_MANUAL_INVOICE_DETAILS: "/pl-customer-manual-invoice-details",
  LEDGER_INVOICE_LIST: "/pl-customer-invoice-list",
  LEDGER_LOADING_ADVICE_DETAIL: "/pl-loading-advice-detail",
  LEDGER_MANUAL_INVOICE_CREATION: "/pl-customer-manual-invoice-create",

  //RFQ
  LEDGER_RFQ_CREATION: "/pl-rfq-creation",
  LEDGER_RFQ_CREATION_MANUAL: "/pl-rfq-manual-creation",
  LEDGER_RFQ_LIST: "/pl-rfq-list",
  LEDGER_RFQ_DETAIL: "/pl-rfq-details",
  LEDGER_RFQ_COMMERCIAL_EVALUATION: "/pl-commercial-evaluation",

  //Indent
  LEDGER_INDENT_CREATION: "/pl-customer-indent-create",
  LEDGER_INDENT_LIST: "/pl-customer-indent-list",
  LEDGER_INDENT_DETAILS: "/pl-customer-indent-details",

  //Purchase Order
  LEDGER_PURCHASE_ORDER_CREATION: "/pl-purchase-order-create",
  LEDGER_PURCHASE_ORDER_LIST: "/pl-purchase-order-list",
  LEDGER_PURCHASE_ORDER_DETAILS: "/pl-purchase-order-details",
  LEDGER_PURCHASE_ORDER_DELIVERY_CONFIRM: "/pl-purchase-order-grn-confirm",
  LEDGER_PURCHASE_ORDER_DELIVERY_DETIALS: "/pl-purchase-order-grn-detials",
  LEDGER_PURCHASE_ORDER_PAYMENT_LIST: "/pl-purchase-order-payment-list",
  LEDGER_ORDER_BOOKING: "/pl-order-booking",
  LEDGER_ORDER_SCHEDULING: "/pl-order-scheduling",
  LEDGER_LOADING_ADVICE: "/pl-loading-advice-list",

  //Quotation
  LEDGER_QUOTATION_LIST: "/pl-quotation-list",
  LEDGER_QUOTATION_CREATION: "/pl-quotation-creation",
  LEDGER_QUOTATION_DETAILS: "/pl-quotation-details",

  //vendor
  LEDGER_VENDOR_RFQ_LIST: "/pl-vendor-rfq-list",
  LEDGER_VENDOR_RFQ_DETAIL: "/pl-vendor-rfq-detail",
  LEDGER_VENDOR_QUOTATION_LIST: "/pl-vendor-quotation-list",

  //Bulck Upload
  LEDGER_ORDER_BULCK_UPLOAD: "/pl-order-bulck-upload",

  /*Credit Approval Request Form*/
  LEDGER_CREDIT_POLICY_REQUEST_FORM_DETAILS:
    "/pl-credit-policy-request-form-details",
  LEDGER_CREDIT_POLICY_REQUEST_LIST: "/pl-credit-policy-request-list",

  //Purchaase
  LEDGER_PURCHASE_LIST: "/pl-purchase-list",
  LEDGER_PURCHASE_CREATION: "/pl-purchase-creation",
  LEDGER_PURCHASE_DETAILS: "/pl-purchase-details",

  //custom report
  LEDGER_CUSTOM_REPORTS: "/pl-custom-reports",
  LEDGER_SALES_OFFICER_CUSTOM_REPORTS: "/pl-sales-officer-custom-reports",

  //company
  LEDGER_COMPANY_REGISTRATION: "/pl-company-registration",
  LEDGER_COMPANY_LIST: "/pl-company-list",
  LEDGER_COMPANY_DETAILS: "/pl-company-details",

  LEDGER_MATERIAL_LIST: "/pl-material-list",

  //pitti cash
  LEDGER_PETTY_CASH_LIST: "/pl-petty-cash-list",
  LEDGER_PETTY_CASH_CREATE: "/pl-petty-cash-create",

  //Employe
  LEDGER_EMP_REGISTRATION: "/pl-emp-registration",
  LEDGER_EMP_LIST: "/pl-employee-list",
  LEDGER_EMP_DETAILS: "/pl-employee-details",

  // Customer V2 Supplier
  LEDGER_SUPPILER_REGISTRATION: "/pl-supplier-registration",
  LEDGER_SUPPILER_LIST: "/pl-supplier-list",
  LEDGER_SUPPILER_MASS_UPLOAD: "/pl-supplier-mass-upload",
  LEDGER_SUPPLIER_MASTER_CREATE: "/pl-supplier-master-creation",

  /* Master */
   LEDGER_MASTER_VEHICLE_CREATE: '/pl-vehicle-creation',
   LEDGER_MASTER_VEHICLE_LIST: '/pl-vehicle-list',
   LEDGER_MASTER_VEHICLE_DETAILS: '/pl-vehicle-details',

   /* Master */
   LEDGER_MASTER_DRIVER_CREATE: '/pl-driver-creation',
   LEDGER_MASTER_DRIVER_LIST: '/pl-driver-list',
   LEDGER_MASTER_DRIVER_DETAILS: '/pl-driver-details',

   /* tansporter */
   LEDGER_TRANSPORT_REQUEST_CREATE:'/pl-transport-request-creation',
   LEDGER_TRANSPORT_REQUEST_LIST:'/pl-transport-request-list',
   LEDGER_TRANSPORT_REQUEST_DETAILS:'/pl-transport-request-details',

   /* Master/Transporter */
   LEDGER_MASTER_TRANSPORTER_REGISTRATION: '/pl-transporter-registration',
   LEDGER_MASTER_TRANSPORTER_LIST: '/pl-transporter-list',
   LEDGER_MASTER_TRANSPORTER_DETAILS: '/pl-transporter-details',

   //gate Entery
   LEDGER_IN_WORD_OUT_WORD_LIST: "/pl-inward-outward-list",
   LEDGER_GATE_ENTRY_UPDATE: "/pl-gate-details",

   //fuel Entry
   LEDGER_FUEL_ENTRY_LIST:"/pl-fuel-entry-list",

   //Bunk 
   LEDGER_MASTER_BUNK_CREATE: '/pl-bunk-creation',
   LEDGER_MASTER_BUNK_LIST: '/pl-bunk-list',
   LEDGER_MASTER_BUNK_DETAILS: '/pl-bunk-details',
   
   //Bank
   LEDGER_BANK_LIST:'/pl-bank-list',

   LEDGER_CUSTOMER_LIST:"/pl-customer-master-list",
   LEDGER_CUSTOMER_CREATE:"/pl-customer-create",
   LEDGER_TRANSPORT_REQ_LIST:"/pl-transport-request-list-intransit",
   LEDGER_TRANSPORT_REQ_LIST_ACK:"/pl-transport-request-list-delivered",
   LEDGER_DELIVERY_PAYMENT_LIST:"/pl-dirver-payment-list",
   LEDGER_FUEL_ENTRY_CREATE:"/pl-fuel-entry-create",


});
